// import { animate } from "motion"
import { animate, scroll } from "motion";

animate(".column", { backgroundColor: "blue", x: "25%", color: ["red", "yellow", "green", "blue"] }, { duration: 5.0 }, { easing: [ "ease-in"] }, { repeat: Infinity })
